<ng-container *ngFor="let list of (group | getObjectProperties)">
    <li apply="theme" background="section" mouse-action="background-section-hover"
        class="mouse-action-theme-waves waves-effect border-all" style="display: block;">
        <ng-container
            *ngTemplateOutlet="hiddenListTemplate; context:{ value: list, text: list, type: 0, checked: (group[list] | getObjectProperties:'values' | getIndexFromMultipleArray:'check' | getBooleanResult:'true':'every':'bool') };">
        </ng-container>
    </li>
    <ng-container *ngFor="let item of (group[list] | getObjectProperties);">
        <li apply="theme" background="section" mouse-action="background-section-hover"
            class="mouse-action-theme-waves waves-effect" style="display: block;">
            <ng-container
                *ngTemplateOutlet="hiddenListTemplate; context:{ value: group[list][item].id || item, text: item, type: list, checked: group[list][item].check };">
            </ng-container>
        </li>
    </ng-container>
</ng-container>
<!-- Select Multiple Template -->
<ng-template #hiddenListTemplate let-value="value" let-text="text" let-type="type" let-checked="checked">
    <form apply="theme">
        <label>
            <input type="checkbox" [value]="value" [checked]="checked"
                (change)="checkSelection($event.target.checked, $event.target.value, type, text)" />
            <span [ngClass]="{ 'bld': type === 0 }" class="fnt-10-i">{{text}}</span>
        </label>
    </form>
</ng-template>